var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.lesson)?_c('div',{staticClass:"channel-lesson m-auto"},[(_vm.lesson)?_c('live-player',{attrs:{"liveData":_vm.lesson}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }